export const translationEngDefault = {
    SkhemataFaqCategories: {
        categoriesTitle: "Categories",
        allCategories: "All Categories",
    }
};
//# sourceMappingURL=eng.js.map